export default __webpack_public_path__ + "assets/certificates/CE-MRL.f50dca11.pdf";